// src/pages/ContactUs.jsx
import React from 'react';

export default function ContactUs() {
  return (
    <div className="container my-5">
      <h1 className="text-center mb-5">Contact Us</h1>

      <div className="row g-5">
        <div className="col-md-6">
          <div className="card h-100 shadow-lg">
            <div className="card-body p-5">
              <h3 className="mb-4">Get in Touch</h3>
              <div className="mb-4">
                <h5><i className="bi bi-geo-alt-fill me-2"></i>Address</h5>
                <p>123 Wellness Street<br/>Lusaka Zambia</p>
              </div>
              <div className="mb-4">
                <h5><i className="bi bi-telephone-fill me-2"></i>Phone</h5>
                <p>+260 977 000-000</p>
              </div>
              <div className="mb-4">
                <h5><i className="bi bi-envelope-fill me-2"></i>Email</h5>
                <p>care@nurturenestmidwifery.com</p>
              </div>
              <div className="mb-4">
                <h5><i className="bi bi-clock-fill me-2"></i>Hours</h5>
                <p>Monday-Friday: 8am - 6pm<br/>Saturday: 9am - 2pm</p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card shadow-lg">
            <div className="card-body p-5">
              <h3 className="mb-4">Send a Message For Enquiries</h3>
              <form>
                <div className="mb-3">
                  <input type="text" className="form-control" placeholder="Your Name" required />
                </div>
                <div className="mb-3">
                  <input type="email" className="form-control" placeholder="Email Address" required />
                </div>
                <div className="mb-3">
                  <input type="text" className="form-control" placeholder="Subject" required />
                </div>
                <div className="mb-3">
                  <textarea className="form-control" rows="5" placeholder="Your Message" required></textarea>
                </div>
                <button type="submit" className="btn btn-primary btn-lg w-100">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-5">
        <iframe 
          title="Clinic Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15769.998763795554!2d28.2933461!3d-15.3875256!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x19408c2049c45df1%3A0x80f8fef5e35a2e60!2sLusaka%2C%20Zambia!5e0!3m2!1sen!2sus!4v1689878907895!5m2!1sen!2sus" 
          width="100%" 
          height="450" 
          style={{border:0}}
          allowFullScreen
          loading="lazy"
          className="rounded-4 shadow-lg"
        ></iframe>
      </div>
    </div>
  );
}